import React from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Home from "../home/home";
import BlogGrid from "../blog/blog-grid";
import BlogGridSidebarLeft from "../blog/blog-grid-sidebar-left";
import BlogGridSidebarRight from "../blog/blog-grid-sidebar-right";
import BlogList from "../blog/blog-list";
import BlogListSidebarRight from "../blog/blog-list-sidebar-right";
import BlogListSidebarLeft from "../blog/blog-list-sidebar-left";
import AboutUs from "../pages/about-us";
import BookingCancelled from "../coaches/booking-cancelled";
import BookingCompleted from "../coaches/booking-completed";
import AddCourt from "../coaches/add-court";
import AllCourt from "../coaches/all-court";
import AppointmentDetails from "../coaches/appointment-details";
import BlogCarousel from "../blog/blog-carousel";
import BlogDetails from "../blog/blog-details";
import BlogDetailsSidebarLeft from "../blog/blog-details-sidebar-left";
import BlogDetailsSidebarRight from "../blog/blog-details-sidebar-right";
import CoachDetail from "../coaches/coach-detail";
import CoachDetails from "../coaches/coach-details";
import CoachEarning from "../coaches/coach-earning";
import CoachesGrid from "../coaches/coaches-grid";
import CoachesGridSidebar from "../coaches/coaches-grid-sidebar";
import CoachesList from "../coaches/coaches-list";
import CoachesListSidebar from "../coaches/coaches-list-sidebar";
import CoachesMap from "../coaches/coaches-map";
import CoachRequest from "../coaches/coach-request";
import CoachWallet from "../coaches/coach-wallet";
import CoachTimeDate from "../coaches/coach-timedate";
import CoachProfile from "../coaches/coach-profile";
import CoachPersonalInfo from "../coaches/coach-personalinfo";
import CoachPayment from "../coaches/coach-payment";
import CoachOrederConfirm from "../coaches/coach-order-confirm";
import CoachMapSideBar from "../coaches/coach-map-sidebar";
import ComingSoon from "../pages/coming-soon";
import ContactUs from "../contact-us/contact-us";
import ActiveCourt from "../coaches/court-active";
import InactiveCourt from "../coaches/court-inactive";
import Error404 from "../pages/error-404";
import Events from "../pages/events";
import EventDetails from "../pages/event-details";
import CageCheckout from "../coaches/cage-checkout";
import CageDetails from "../coaches/cage-details";
import CageOrderConfirm from "../coaches/cage-order-confirm";
import CagePersonalInfo from "../coaches/cagepersonalinfo";
import EarningCoaching from "../coaches/earning-coaching";
import LessonTimedate from "../coaches/lesson-timedate";
import LessonType from "../coaches/lesson-type";
import ListingGridSidebar from "../listing/listing-grid-sidebar";
import ListingGrid from "../listing/listing-grid";
import ListingListSidebar from "../listing/listing-list-sidebar";
import ListingMapSidebar from "../listing/listing-map-sidebar";
import UserComplete from "../user/user-complete";
import UserDashboardProfiles from "../user/user-dashboard-profiles";
import UserDashboard from "../user/user-dashboard";
import UserInvoice from "../user/user-invoice";
import CoachDashboard from "../coaches/coach-dashboard";
import ServiceDetail from "../pages/service-detail";
import Services from "../pages/services";
import SettingLesson from "../coaches/setting-lesson";
import SettingPassword from "../coaches/setting-password";
import SettingAvailability from "../coaches/setting-availability";
import TermsCondition from "../pages/terms-condition";
import ProfileOtherSetting from "../coaches/profile-othersetting";
import PrivacyPolicy from "../pages/privacy-policy";
import Pricing from "../pages/pricing";
import OurTeams from "../pages/our-teams";
import MyProfile from "../pages/my-profile";
import ListingList from "../listing/listing-list";
import ListingMap from "../listing/listing-map";
import Testimonials from "../pages/testimonials";
import TestimonialsCarousel from "../pages/testimonials-carousel";
import UserBookings from "../user/user-bookings";
import CoachBooking from "../coaches/coach-booking";
import CoachChat from "../coaches/coaches-chat";
import Faq from "../pages/faq";
import ForgotPassword from "../auth/forgot-password";
import Gallery from "../pages/gallery";
import Invoice from "../coaches/invoice";
import LessonOrderConfirm from "../coaches/lessonOrderconfirm";
import LessonPayment from "../coaches/lesson-payment";
import LessonPersonalinfo from "../coaches/lessonPersonalinfo";
import UserChat from "../user/user-chat";
import UserCoaches from "../user/user-coaches";
import Signin from "../auth/register";
import UserWallet from "../user/user-wallet";
import VenueDetails from "../coaches/venue-details";
import Login from "../auth/login";
import UserProfile from "../user/user-profile";
import UserSettingPassword from "../user/user-setting-password";
import UserProfileOtherSetting from "../user/user-profile-othersetting";
import UserCancelled from "../user/user-cancelled";
import UserOngoing from "../user/user-ongoing";
import ChangePassword from "../auth/change-password";
import Maintenance from "../pages/maintenance";

// Added Screens

import TenvicLogin from "../tenvic/tenvicLogin";
import TenvicForgotPassword from "../tenvic/tenvicForgotpassword";
import TenvicUsers from "../tenvic/users";
import TenvicProfile from "../tenvic/profile";
import TenvicRoles from "../tenvic/RBAC/roles";
import TenvicPermissions from "../tenvic/RBAC/permissions";
import TenvicRolePermission from "../tenvic/RBAC/rolePermission";
import TenvicMenus from "../tenvic/RBAC/menu";
import TenvicSubMenus from "../tenvic/RBAC/subMenu";
import TenvicMenuRole from "../tenvic/RBAC/menuRole";
import Clients from "../tenvic/client/client";
import TenvicUserRoleMenuPermission from "../tenvic/RBAC/userRoleMenuPermission";

import ManipurLogin from "../manipur/manipurLogin";
import ManipurForgotPassword from "../manipur/manipurForgotpassword";
import ManipurUsers from "../manipur/users";
import ManipurProfile from "../manipur/profile";
import ManipurRoles from "../manipur/RBAC/roles";
import ManipurPermissions from "../manipur/RBAC/permissions";
import ManipurRolePermission from "../manipur/RBAC/rolePermission";
import ManipurMenus from "../manipur/RBAC/menu";
import ManipurSubMenus from "../manipur/RBAC/subMenu";
import ManipurSports from "../manipur/Sports/Sports";
import ManipurTalentScout from "../manipur/Talent Scouting/TalentScouting";
import ManipurTalentScoutCriteria from "../manipur/Talent Scouting Selection Criteria/TalentScoutingSelectionCriteria";
import ManipurPasswordReset from "../manipur/passwordreset";
import ManipurUserRoleMenuPermission from "../manipur/RBAC/userRoleMenuPermission";
import Athletes from "../manipur/Athlete/athletesRegister";
import Registration from "../manipur/Athlete/Registration";
import GeoTabs from "../manipur/Geography/geoTabs";
import Batch from "../manipur/Batch/batch";
import BatchAthlete from "../manipur/BatchAthlete/batchAthletes";
import Schedules from "../manipur/Schedule/schedule";
import Assessment from "../manipur/Assessment/assessment";
import CompetitionType from "../manipur/Competition/Competition Type/competitionType";
import CompetitionSports from "../manipur/Competition/Sports/sports";
import CompetitionSportType from "../manipur/Competition/Competition Sports Type/competitionSportType";
import Competitions from "../manipur/Competition/Competitions/competitions";
import CompetitionPerformance from "../manipur/Competition/Competition Performance/competitionPerformance";
import SportsList from "../manipur/Competition/Sports List/sportsList";
import CompetitionsReport from "../manipur/Reports/competitionsReport";
import CompetitionPerformanceReport from "../manipur/Reports/competitionPerformanceReport";
import AthleteReport from "../manipur/Reports/athleteReport";
import ScheduleReport from "../manipur/Reports/scheduleReport";
import AssessmentReport from "../manipur/Reports/assessmentReport";
import AtheleteApprove from "../manipur/Athlete/athleteApprove";
import CenterBatch from "../manipur/Center/Center Batch/centerBatch";
import CenterBatchAthlete from "../manipur/Center/Center Batch Athlete/centerBatchAthlete";
import ProgramLevel from "../manipur/Program Level/programLevel";
import ScheduleType from "../manipur/Schedule Type/scheduleType";
import Skills from "../manipur/Skills/skills";
import CenterSchedules from "../manipur/Center/Center Schedule/centerSchedule";
import CenterAttendance from "../manipur/Center/Center Attendance/centerAttendance";
import CenterAssessment from "../manipur/Center/Center Assessment/centerAssessment";
import CenterAtheleteApprove from "../manipur/Center/Athlete Approve/centerathleteapprove";
import HPCBatch from "../manipur/HPC/HPC Batch/hpcBatch";
import HPCBatchAthlete from "../manipur/HPC/HPC Batch Athlete/hpcBatchAthlete";
import HPCSchedules from "../manipur/HPC/HPC Schedule/hpcSchedule";
import HPCAttendance from "../manipur/HPC/HPC Attendance/hpcAttendance";
import HPCAssessment from "../manipur/HPC/HPC Assessment/hpcAssessment";
import RegisterTabs from "../athlete/Register/registerTabs";
import ManipurAthleteMetrics from "../manipur/Metrics/athleteMetrics";
import Injury from "../manipur/Physiotherapy/Injury";
import InjuryAssessment from "../manipur/Physiotherapy/InjuryAssessment";
import Diagnosis from "../manipur/Physiotherapy/Diagnosis";
import Treatment from "../manipur/Physiotherapy/Treatment";
import Screening from "../manipur/Physiotherapy/Screening";

import AthleteLogin from "../athlete/athleteLogin";
import AthleteDashboard from "../athlete/athleteDashboard";
import AthleteMetrics from "../athlete/Metrics/athleteMetrics";
import AthleteProfile from "../athlete/Profile/Profile";
import AthleteInjury from "../athlete/Physiotherapy/Injury";
import AthleteInjuryAssessment from "../athlete/Physiotherapy/InjuryAssessment";
import AthleteAssessment from "../athlete/Assessment/assessment";
import AthleteDiagnosis from "../athlete/Physiotherapy/Diagnosis";
import AthleteTreatment from "../athlete/Physiotherapy/Treatment";
import AthleteTabs from "../manipur/Athlete/AthleteTabs";
import AthleteBatch from "../athlete/Batch/batch";
import BatchAthletes from "../athlete/BatchAthlete/batchAthletes";
import AthleteSchedules from "../athlete/Schedule/schedule";
import AthleteCenterBatch from "../athlete/Center/Center Batch/centerBatch";
import CenterBatchAthlt from "../athlete/Center/Center Batch Athlete/centerBatchAthlete";
import AthleteCenterSchedules from "../athlete/Center/Center Schedule/centerSchedule";
import AthleteCenterAttendance from "../athlete/Center/Center Attendance/centerAttendance";
import AthleteCenterAssessment from "../athlete/Center/Center Assessment/centerAssessment";
import AthleteHPCBatch from "../athlete/HPC/HPC Batch/hpcBatch";
import AthleteHPCBatchAthlete from "../athlete/HPC/HPC Batch Athlete/hpcBatchAthlete";
import AthleteHPCSchedules from "../athlete/HPC/HPC Schedule/hpcSchedule";
import AthleteHPCAttendance from "../athlete/HPC/HPC Attendance/hpcAttendance";
import AthleteHPCAssessment from "../athlete/HPC/HPC Assessment/hpcAssessment";
import AthleteCompetitionPerformance from "../athlete/Competition Performance/competitionPerformance";
import BloodGroup from "../manipur/Dropdowns/BloodGroup";
import AllergyType from "../manipur/Dropdowns/AllergyType";
import MedicationCategory from "../manipur/Dropdowns/MedicationCategory";
import AlcoholUsage from "../manipur/Dropdowns/AlcoholUsage";
import TobaccoUsage from "../manipur/Dropdowns/TobaccoUsage";
import InjuryType from "../manipur/Dropdowns/InjuryType";
import RegionAffected from "../manipur/Dropdowns/RegionAffected";
import DiagnosisType from "../manipur/Dropdowns/DiagnosisType";
import InjurySeverity from "../manipur/Dropdowns/InjurySeverity";
import InjuryMechanism from "../manipur/Dropdowns/InjuryMechanism";
import InjuryManagementApproach from "../manipur/Dropdowns/InjuryManagementApproach";
import TimeLost from "../manipur/Dropdowns/TimeLost";
import SurgeryCategory from "../manipur/Dropdowns/SurgeryCategory";
import BodyRegion from "../manipur/Dropdowns/BodyRegion";
import RehabilitationDuration from "../manipur/Dropdowns/RehabilitationDuration";
import PhysiologicalType from "../manipur/Dropdowns/PhysiologicalType";
import ScreeningTestType from "../manipur/Dropdowns/ScreeningTestType";
import SymptomType from "../manipur/Dropdowns/SymptomType";
import PainLocationType from "../manipur/Dropdowns/PainLocationType";
import FunctionalLimitationsType from "../manipur/Dropdowns/FunctionalLimitationsType";
import InjuryTreatmentType from "../manipur/Dropdowns/InjuryTreatmentType";
import ConcussionSpecificSymptom from "../manipur/Dropdowns/ConcussionSpecificSymptom";
import GradeType from "../manipur/GradeType/GradeType";
import AssessmentType from "../manipur/AssessmentType/AssessmentType";
import AttendanceType from "../manipur/AttendanceType/AttendanceType";
import AccountType from "../manipur/AccountType/AccountType";
import Onset from "../manipur/Dropdowns/Onset";
import PerformanceTest from "../manipur/Dropdowns/PerformanceTest";
import AssignToCenter from "../manipur/CenterAssignment/AssignToCenter";
import AssignToHPC from "../manipur/HPCAssignment/AssignToHPC";
import OverallAssessment from "../manipur/Physiotherapy/OverallAssessment";
import Psychology from "../manipur/Psychology/Psychology";
import CopingSkillsInventory from "../manipur/Coping Inventory/CopingSkillsInventory";

const routes = all_routes;

const getLoginRedirectPath = () => {
  const path = window.location.pathname;
  if (path.startsWith("/manipur")) return routes.manipurlogin;
  else if (path.startsWith("/athlete")) return routes.athleteLogin;
  return routes.manipurlogin;
  // return routes.tenviclogin;
};

const publicRoutes = [
  {
    path: routes.home,
    element: <Home />,
    route: Route,
  },
  {
    path: routes.blogGrid,
    element: <BlogGrid />,
    route: Route,
  },
  {
    path: routes.blogGridSidebarRight,
    element: <BlogGridSidebarRight />,
    route: Route,
  },
  {
    path: routes.blogGridSidebarLeft,
    element: <BlogGridSidebarLeft />,
    route: Route,
  },
  {
    path: routes.blogList,
    element: <BlogList />,
    route: Route,
  },
  {
    path: routes.blogListSidebarRight,
    element: <BlogListSidebarRight />,
    route: Route,
  },
  {
    path: routes.blogListSidebarLeft,
    element: <BlogListSidebarLeft />,
    route: Route,
  },
  {
    path: routes.aboutUs,
    element: <AboutUs />,
    route: Route,
  },

  {
    path: routes.bookingCancelled,
    element: <BookingCancelled />,
    route: Route,
  },
  {
    path: routes.bookingCompleted,
    element: <BookingCompleted />,
    route: Route,
  },
  {
    path: routes.addCourt,
    element: <AddCourt />,
    route: Route,
  },
  {
    path: routes.allCourt,
    element: <AllCourt />,
    route: Route,
  },
  {
    path: routes.appointmentDetails,
    element: <AppointmentDetails />,
    route: Route,
  },
  {
    path: routes.blogCarousel,
    element: <BlogCarousel />,
    route: Route,
  },
  {
    path: routes.blogDetails,
    element: <BlogDetails />,
    route: Route,
  },
  {
    path: routes.blogDetailsSidebarLeft,
    element: <BlogDetailsSidebarLeft />,
    route: Route,
  },
  {
    path: routes.blogDetailsSidebarRight,
    element: <BlogDetailsSidebarRight />,
    route: Route,
  },
  {
    path: routes.coachDetail,
    element: <CoachDetail />,
    route: Route,
  },
  {
    path: routes.coachDetails,
    element: <CoachDetails />,
    route: Route,
  },
  {
    path: routes.coachEarning,
    element: <CoachEarning />,
    route: Route,
  },
  {
    path: routes.coachesGrid,
    element: <CoachesGrid />,
    route: Route,
  },
  {
    path: routes.coachesGridSidebar,
    element: <CoachesGridSidebar />,
    route: Route,
  },
  {
    path: routes.coachesList,
    element: <CoachesList />,
    route: Route,
  },
  {
    path: routes.coachesListSidebar,
    element: <CoachesListSidebar />,
    route: Route,
  },
  {
    path: routes.coachesMap,
    element: <CoachesMap />,
    route: Route,
  },
  {
    path: routes.coachRequest,
    element: <CoachRequest />,
    route: Route,
  },
  {
    path: routes.coachWallet,
    element: <CoachWallet />,
    route: Route,
  },
  {
    path: routes.coachTimeDate,
    element: <CoachTimeDate />,
    route: Route,
  },
  {
    path: routes.coachProfile,
    element: <CoachProfile />,
    route: Route,
  },
  {
    path: routes.coachPersonalInfo,
    element: <CoachPersonalInfo />,
    route: Route,
  },
  {
    path: routes.coachPayment,
    element: <CoachPayment />,
    route: Route,
  },
  {
    path: routes.coachOrederConfirm,
    element: <CoachOrederConfirm />,
    route: Route,
  },
  {
    path: routes.coachesMapSidebar,
    element: <CoachMapSideBar />,
    route: Route,
  },
  {
    path: routes.contactUs,
    element: <ContactUs />,
    route: Route,
  },
  {
    path: routes.activeCourt,
    element: <ActiveCourt />,
    route: Route,
  },

  {
    path: routes.cagecheckout,
    element: <CageCheckout />,
    route: Route,
  },
  {
    path: routes.cagedetails,
    element: <CageDetails />,
    route: Route,
  },
  {
    path: routes.cageordeconfirm,
    element: <CageOrderConfirm />,
    route: Route,
  },
  {
    path: routes.cagepersonalinfo,
    element: <CagePersonalInfo />,
    route: Route,
  },

  {
    path: routes.inactiveCourt,
    element: <InactiveCourt />,
    route: Route,
  },
  {
    path: routes.events,
    element: <Events />,
    route: Route,
  },
  {
    path: routes.eventdetails,
    element: <EventDetails />,
    route: Route,
  },
  {
    path: routes.inactiveCourt,
    element: <InactiveCourt />,
    route: Route,
  },
  {
    path: routes.earningCoaching,
    element: <EarningCoaching />,
    route: Route,
  },
  {
    path: routes.lessonTimeDate,
    element: <LessonTimedate />,
    route: Route,
  },
  {
    path: routes.lessonType,
    element: <LessonType />,
    route: Route,
  },
  {
    path: routes.listingGridSidebar,
    element: <ListingGridSidebar />,
    route: Route,
  },
  {
    path: routes.listingGrid,
    element: <ListingGrid />,
    route: Route,
  },
  {
    path: routes.listingList,
    element: <ListingList />,
    route: Route,
  },
  {
    path: routes.listingListSidebar,
    element: <ListingListSidebar />,
    route: Route,
  },
  {
    path: routes.listingMap,
    element: <ListingMap />,
    route: Route,
  },
  {
    path: routes.listingMapSidebar,
    element: <ListingMapSidebar />,
    route: Route,
  },
  {
    path: routes.userComplete,
    element: <UserComplete />,
    route: Route,
  },
  {
    path: routes.userDashboardProfiles,
    element: <UserDashboardProfiles />,
    route: Route,
  },
  {
    path: routes.userDashboard,
    element: <UserDashboard />,
    route: Route,
  },
  {
    path: routes.userInvoice,
    element: <UserInvoice />,
    route: Route,
  },
  {
    path: routes.coachDashboard,
    element: <CoachDashboard />,
    route: Route,
  },
  {
    path: routes.serviceDetail,
    element: <ServiceDetail />,
    route: Route,
  },
  {
    path: routes.services,
    element: <Services />,
    route: Route,
  },
  {
    path: routes.settingLesson,
    element: <SettingLesson />,
    route: Route,
  },
  {
    path: routes.settingPassword,
    element: <SettingPassword />,
    route: Route,
  },
  {
    path: routes.settingAvalibilty,
    element: <SettingAvailability />,
    route: Route,
  },
  {
    path: routes.termsCondition,
    element: <TermsCondition />,
    route: Route,
  },
  {
    path: routes.profileOtherSetting,
    element: <ProfileOtherSetting />,
    route: Route,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
    route: Route,
  },
  {
    path: routes.pricing,
    element: <Pricing />,
    route: Route,
  },
  {
    path: routes.ourTeams,
    element: <OurTeams />,
    route: Route,
  },
  {
    path: routes.myProfile,
    element: <MyProfile />,
    route: Route,
  },
  {
    path: routes.testimonials,
    element: <Testimonials />,
    route: Route,
  },
  {
    path: routes.testimonialsCarousel,
    element: <TestimonialsCarousel />,
    route: Route,
  },
  {
    path: routes.userBookings,
    element: <UserBookings />,
    route: Route,
  },
  {
    path: routes.coachBooking,
    element: <CoachBooking />,
    route: Route,
  },
  {
    path: routes.coachChat,
    element: <CoachChat />,
    route: Route,
  },
  {
    path: routes.faq,
    element: <Faq />,
    route: Route,
  },

  {
    path: routes.gallery,
    element: <Gallery />,
    route: Route,
  },
  {
    path: routes.invoice,
    element: <Invoice />,
    route: Route,
  },
  {
    path: routes.lessonOrderConfirm,
    element: <LessonOrderConfirm />,
    route: Route,
  },
  {
    path: routes.lessonPayment,
    element: <LessonPayment />,
    route: Route,
  },
  {
    path: routes.lessonPersonalinfo,
    element: <LessonPersonalinfo />,
    route: Route,
  },
  {
    path: routes.userChat,
    element: <UserChat />,
    route: Route,
  },
  {
    path: routes.userCoaches,
    element: <UserCoaches />,
    route: Route,
  },
  {
    path: routes.userProfile,
    element: <UserProfile />,
    route: Route,
  },
  {
    path: routes.userSettingPassword,
    element: <UserSettingPassword />,
    route: Route,
  },
  {
    path: routes.userProfileOtherSetting,
    element: <UserProfileOtherSetting />,
    route: Route,
  },
  {
    path: routes.userCancelled,
    element: <UserCancelled />,
    route: Route,
  },
  {
    path: routes.userWallet,
    element: <UserWallet />,
    route: Route,
  },
  {
    path: routes.venueDetails,
    element: <VenueDetails />,
    route: Route,
  },
  {
    path: routes.userOngoing,
    element: <UserOngoing />,
    route: Route,
  },
  {
    path: routes.changePassword,
    element: <ChangePassword />,
    route: Route,
  },


  {
    path: routes.tenvicUsers,
    element: <TenvicUsers />,
    route: Route,
  },
  {
    path: routes.tenvicRoles,
    element: <TenvicRoles />,
    route: Route,
  },
  {
    path: routes.tenvicPermissions,
    element: <TenvicPermissions />,
    route: Route,
  },
  {
    path: routes.tenvicRolePermissions,
    element: <TenvicRolePermission />,
    route: Route,
  },
  {
    path: routes.tenvicMenus,
    element: <TenvicMenus />,
    route: Route,
  },
  {
    path: routes.tenvicSubMenus,
    element: <TenvicSubMenus />,
    route: Route,
  },
  {
    path: routes.tenvicMenuRole,
    element: <TenvicMenuRole />,
    route: Route,
  },
  {
    path: routes.tenvicProfile,
    element: <TenvicProfile />,
    route: Route,
  },
  {
    path: routes.tenvicUserRBAC,
    element: <TenvicUserRoleMenuPermission />,
    route: Route,
  },
  {
    path: routes.tenvicClients,
    element: <Clients />,
    route: Route,
  },


  //manipur

  {
    path: routes.manipurUsers,
    element: <ManipurUsers />,
    route: Route,
  },
  {
    path: routes.manipurAllAthletes,
    element: <AthleteTabs />,
    route: Route,
  },
  {
    path: routes.manipurAccountType,
    element: <AccountType />,
    route: Route,
  },
  {
    path: routes.manipurRoles,
    element: <ManipurRoles />,
    route: Route,
  },
  {
    path: routes.manipurPermissions,
    element: <ManipurPermissions />,
    route: Route,
  },
  {
    path: routes.manipurRolePermissions,
    element: <ManipurRolePermission />,
    route: Route,
  },
  {
    path: routes.manipurMenus,
    element: <ManipurMenus />,
    route: Route,
  },
  {
    path: routes.manipurSubMenus,
    element: <ManipurSubMenus />,
    route: Route,
  },
  {
    path: routes.manipurProfile,
    element: <ManipurProfile />,
    route: Route,
  },
  {
    path: routes.manipurUserRBAC,
    element: <ManipurUserRoleMenuPermission />,
    route: Route,
  },
  {
    path: routes.manipurSports,
    element: <ManipurSports />,
    route: Route,
  },
  {
    path: routes.manipurTalentScout,
    element: <ManipurTalentScout />,
    route: Route,
  },
  {
    path: routes.manipurTalentScoutCriteria,
    element: <ManipurTalentScoutCriteria />,
    route: Route,
  },
  {
    path: routes.manipurGeography,
    element: <GeoTabs />,
    route: Route,
  },
  {
    path: routes.manipurBatch,
    element: <Batch />,
    route: Route,
  },
  {
    path: routes.manipurBatchAthlete,
    element: <BatchAthlete />,
    route: Route,
  },
  {
    path: routes.manipurTlntSctAthlt,
    element: <AtheleteApprove />,
    route: Route,
  },
  {
    path: routes.manipurSchedule,
    element: <Schedules />,
    route: Route,
  },
  {
    path: routes.manipurAssessment,
    element: <Assessment />,
    route: Route,
  },
  {
    path: routes.manipurCompetitionType,
    element: <CompetitionType />,
    route: Route,
  },
  {
    path: routes.manipurCompetitionSports,
    element: <CompetitionSports />,
    route: Route,
  },
  {
    path: routes.manipurCompetitionSportType,
    element: <CompetitionSportType />,
    route: Route,
  },
  {
    path: routes.manipurCompetition,
    element: <Competitions />,
    route: Route,
  },
  {
    path: routes.manipurCompetitionPerformance,
    element: <CompetitionPerformance />,
    route: Route,
  },
  {
    path: routes.manipurSportsList,
    element: <SportsList />,
    route: Route,
  },
  {
    path: routes.manipurCompetitionsReport,
    element: <CompetitionsReport />,
    route: Route,
  },
  {
    path: routes.manipurCompetitionPerformanceReport,
    element: <CompetitionPerformanceReport />,
    route: Route,
  },
  {
    path: routes.manipurAthleteReport,
    element: <AthleteReport />,
    route: Route,
  },
  {
    path: routes.manipurScheduleReport,
    element: <ScheduleReport />,
    route: Route,
  },
  {
    path: routes.manipurTestResultsReport,
    element: <AssessmentReport />,
    route: Route,
  },
  {
    path: routes.manipurProgramLevel,
    element: <ProgramLevel />,
    route: Route,
  },
  {
    path: routes.manipurSkills,
    element: <Skills />,
    route: Route,
  },
  {
    path: routes.manipurGradeType,
    element: <GradeType />,
    route: Route,
  },
  {
    path: routes.manipurAssessmentType,
    element: <AssessmentType />,
    route: Route,
  },
  {
    path: routes.manipurAttendanceType,
    element: <AttendanceType />,
    route: Route,
  },
  {
    path: routes.manipurCenterBatch,
    element: <CenterBatch />,
    route: Route,
  },
  {
    path: routes.manipurCenterBatchAthlete,
    element: <CenterBatchAthlete />,
    route: Route,
  },
  {
    path: routes.manipurCenterSchedule,
    element: <CenterSchedules />,
    route: Route,
  },
  {
    path: routes.manipurCenterAttendance,
    element: <CenterAttendance />,
    route: Route,
  },
  {
    path: routes.manipurCenterAssessment,
    element: <CenterAssessment />,
    route: Route,
  },
  {
    path: routes.manipurCenterAthleteApprove,
    element: <CenterAtheleteApprove />,
    route: Route,
  },

  {
    path: routes.manipurHPCBatch,
    element: <HPCBatch />,
    route: Route,
  },
  {
    path: routes.manipurHPCBatchAthlete,
    element: <HPCBatchAthlete />,
    route: Route,
  },
  {
    path: routes.manipurHPCSchedule,
    element: <HPCSchedules />,
    route: Route,
  },
  {
    path: routes.manipurHPCAttendance,
    element: <HPCAttendance />,
    route: Route,
  },
  {
    path: routes.manipurHPCAssessment,
    element: <HPCAssessment />,
    route: Route,
  },
  {
    path: routes.manipurAthleteMetrics,
    element: <ManipurAthleteMetrics />,
    route: Route,
  },
  {
    path: routes.manipurInjury,
    element: <Injury />,
    route: Route,
  },
  {
    path: routes.manipurInjuryAssessment,
    element: <InjuryAssessment />,
    route: Route,
  },
  {
    path: routes.manipurInjuryDiagnosis,
    element: <Diagnosis />,
    route: Route,
  },
  {
    path: routes.manipurInjuryTreatment,
    element: <Treatment />,
    route: Route,
  },
  {
    path: routes.manipurScreening,
    element: <Screening />,
    route: Route,
  },
  {
    path: routes.manipurBldGrp,
    element: <BloodGroup />,
    route: Route,
  },
  {
    path: routes.manipurAlrgyTyp,
    element: <AllergyType />,
    route: Route,
  },
  {
    path: routes.manipurMedCtgry,
    element: <MedicationCategory />,
    route: Route,
  },
  {
    path: routes.manipurAlcUse,
    element: <AlcoholUsage />,
    route: Route,
  },
  {
    path: routes.manipurTbcoUse,
    element: <TobaccoUsage />,
    route: Route,
  },
  {
    path: routes.manipurInjTyp,
    element: <InjuryType />,
    route: Route,
  },
  {
    path: routes.manipurRgnAfctd,
    element: <RegionAffected />,
    route: Route,
  },
  {
    path: routes.manipurDiagType,
    element: <DiagnosisType />,
    route: Route,
  },
  {
    path: routes.manipurInjSvrty,
    element: <InjurySeverity />,
    route: Route,
  },
  {
    path: routes.manipurInjMech,
    element: <InjuryMechanism />,
    route: Route,
  },
  {
    path: routes.manipurInjMgmt,
    element: <InjuryManagementApproach />,
    route: Route,
  },
  {
    path: routes.manipurTimeLost,
    element: <TimeLost />,
    route: Route,
  },
  {
    path: routes.manipurSurgCtgry,
    element: <SurgeryCategory />,
    route: Route,
  },
  {
    path: routes.manipurBdyRgn,
    element: <BodyRegion />,
    route: Route,
  },
  {
    path: routes.manipurRehabDur,
    element: <RehabilitationDuration />,
    route: Route,
  },
  {
    path: routes.manipurPhysioType,
    element: <PhysiologicalType />,
    route: Route,
  },
  {
    path: routes.manipurScrnTstTyp,
    element: <ScreeningTestType />,
    route: Route,
  },
  {
    path: routes.manipurSympTyp,
    element: <SymptomType />,
    route: Route,
  },
  {
    path: routes.manipurPainLocTyp,
    element: <PainLocationType />,
    route: Route,
  },
  {
    path: routes.manipurFuncLmt,
    element: <FunctionalLimitationsType />,
    route: Route,
  },
  {
    path: routes.manipurInjTreatTyp,
    element: <InjuryTreatmentType />,
    route: Route,
  },
  {
    path: routes.manipurCncsnSymp,
    element: <ConcussionSpecificSymptom />,
    route: Route,
  },
  {
    path: routes.manipurOnst,
    element: <Onset />,
    route: Route,
  },
  {
    path: routes.manipurPrfrmTst,
    element: <PerformanceTest />,
    route: Route,
  },
  {
    path: routes.manipurAsgnCntr,
    element: <AssignToCenter />,
    route: Route,
  },
  {
    path: routes.manipurAsgnHPC,
    element: <AssignToHPC />,
    route: Route,
  },
  {
    path: routes.manipurOverAllAssessment,
    element: <OverallAssessment />,
    route: Route,
  },
  {
    path: routes.manipurPsychology,
    element: <Psychology />,
    route: Route,
  },
  {
    path: routes.manipurPsychologyAcsi,
    element: <CopingSkillsInventory />,
    route: Route,
  },


  {
    path: routes.athleteDashboard,
    element: <AthleteDashboard />,
    route: Route,
  },
  {
    path: routes.athleteMetrics,
    element: <AthleteMetrics />,
    route: Route,
  },
  {
    path: routes.athleteProfile,
    element: <AthleteProfile />,
    route: Route,
  },
  {
    path: routes.athleteInjury,
    element: <AthleteInjury />,
    route: Route,
  },
  {
    path: routes.athleteInjuryAssessment,
    element: <AthleteInjuryAssessment />,
    route: Route,
  },
  {
    path: routes.athleteInjuryDiagnosis,
    element: <AthleteDiagnosis />,
    route: Route,
  },
  {
    path: routes.athleteInjuryTreatment,
    element: <AthleteTreatment />,
    route: Route,
  },
  {
    path: routes.athleteBatch,
    element: <AthleteBatch />,
    route: Route,
  },
  {
    path: routes.athleteBatchAthlete,
    element: <BatchAthletes />,
    route: Route,
  },
  {
    path: routes.athleteSchedule,
    element: <AthleteSchedules />,
    route: Route,
  },
  {
    path: routes.athleteAssessment,
    element: <AthleteAssessment />,
    route: Route,
  },
  {
    path: routes.athleteCenterBatch,
    element: <AthleteCenterBatch />,
    route: Route,
  },
  {
    path: routes.athleteCenterBatchAthlete,
    element: <CenterBatchAthlt />,
    route: Route,
  },
  {
    path: routes.athleteCenterSchedule,
    element: <AthleteCenterSchedules />,
    route: Route,
  },
  {
    path: routes.athleteCenterAttendance,
    element: <AthleteCenterAttendance />,
    route: Route,
  },
  {
    path: routes.athleteCenterAssessment,
    element: <AthleteCenterAssessment />,
    route: Route,
  },
  {
    path: routes.athleteHPCBatch,
    element: <AthleteHPCBatch />,
    route: Route,
  },
  {
    path: routes.athleteHPCBatchAthlete,
    element: <AthleteHPCBatchAthlete />,
    route: Route,
  },
  {
    path: routes.athleteHPCSchedule,
    element: <AthleteHPCSchedules />,
    route: Route,
  },
  {
    path: routes.athleteHPCAttendance,
    element: <AthleteHPCAttendance />,
    route: Route,
  },
  {
    path: routes.athleteHPCAssessment,
    element: <AthleteHPCAssessment />,
    route: Route,
  },
  {
    path: routes.athleteCompetitionPerformance,
    element: <AthleteCompetitionPerformance />,
    route: Route,
  },

  {
    path: "/",
    name: "Root",
    element: <Navigate to={getLoginRedirectPath()} />,
    route: Route,
  },
  {
    path: "*",
    name: "NotFound",
    element: <Navigate to={getLoginRedirectPath()} />,
    route: Route,
  },
];

const withoutHeaderRoutes = [
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Signin />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.maintenance,
    element: <Maintenance />,
    route: Route,
  },
  {
    path: routes.forgotPasssword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.tenviclogin,
    element: <TenvicLogin />,
    route: Route,
  },
  {
    path: routes.tenvicForgotPassword,
    element: <TenvicForgotPassword />,
    route: Route,
  },
  {
    path: routes.manipurlogin,
    element: <ManipurLogin />,
    route: Route,
  },
  {
    path: routes.manipurForgotPassword,
    element: <ManipurForgotPassword />,
    route: Route,
  },
  {
    path: routes.manipurPasswordReset,
    element: <ManipurPasswordReset />,
    route: Route,
  },
  {
    path: routes.manipurAthletesRegs,
    element: <Registration />,
    route: Route,
  },
  {
    path: routes.manipurAthletes,
    // element: <Athletes />,
    element: <RegisterTabs />,
    route: Route,
  },
  {
    path: routes.athleteLogin,
    element: <AthleteLogin />,
    route: Route,
  },

];
export { publicRoutes, withoutHeaderRoutes };
